import * as stylex from '@stylexjs/stylex';
import '../../styles/tokens.stylex';
import { borderRadius, color, fontSizes, fontWeights, shadow, size, spacing, typographyColor } from '../../styles/tokens.stylex';

//default sizes
export const buttonSizes = {
  minHeight: "var(--x1getavp)",
  paddingInline: "var(--x4on1uv)",
  paddingBlock: "var(--xu9mcrg)",
  borderWidth: "var(--xsu68fu)",
  borderRadius: "var(--x1mgiybc)",
  gap: "var(--x1oq12e0)",
  iconSize: "var(--x1m5zl11)",
  fontSize: "var(--x1weothn)",
  __varGroupHash__: "x1tpalzc"
};
export const buttonSizesMediaAction = {
  x1tpalzc: "x16rfjnb x1tpalzc",
  $$css: true
};
export const buttonSizesMediaActionLarge = {
  x1tpalzc: "x1n6bhhe x1tpalzc",
  $$css: true
};
export const buttonSizesCompact = {
  x1tpalzc: "x1ew485v x1tpalzc",
  $$css: true
};
export const buttonSizesXCompact = {
  x1tpalzc: "xi7j1yv x1tpalzc",
  $$css: true
};

//default PRIMARY SOLID theme
export const buttonTheme = {
  backgroundColor: "var(--xkpa4x5)",
  backgroundColorHover: "var(--x1trzxfq)",
  backgroundColorPressed: "var(--x1f4705z)",
  backgroundImage: "var(--x1i0vjzd)",
  backgroundImageHover: "var(--xunfjxn)",
  backgroundImagePressed: "var(--xjk7rxq)",
  borderColor: "var(--x1bl6dh6)",
  borderColorHover: "var(--xu3fn7t)",
  borderColorPressed: "var(--x1o4r1oh)",
  contentColor: "var(--xe7c87r)",
  textShadow: "var(--x11f880c)",
  boxShadow: "var(--x4n2cg3)",
  borderStyle: "var(--xcf4dfn)",
  borderWidth: "var(--x16pdb9p)",
  fontWeight: "var(--x13mh4o)",
  hoverFilter: "var(--x80tkbu)",
  __varGroupHash__: "x8l3xik"
};
export const secondarySolidButtonTheme = {
  x8l3xik: "x1q1wsh5 x8l3xik",
  $$css: true
};

//default NEUTRAL theme
export const ghostButtonTheme = {
  x8l3xik: "x13rx1pu x8l3xik",
  $$css: true
};
export const primaryGhostButtonTheme = {
  x8l3xik: "x1wu5unv x8l3xik",
  $$css: true
};
export const cardLinkButtonTheme = {
  x8l3xik: "xcwmq9o x8l3xik",
  $$css: true
};
export const mediaActionButtonTheme = {
  x8l3xik: "x5l9hfj x8l3xik",
  $$css: true
};
export const mediaActionLargeButtonTheme = {
  x8l3xik: "x1lt48ap x8l3xik",
  $$css: true
};
export const submitButtonTheme = {
  x8l3xik: "xeiuw6l x8l3xik",
  $$css: true
};